export default __webpack_public_path__ + "static/media/goToLinkIcon.4c40373c.svg";